__webpack_require__.p = "https://bundle.stayforlong.com/20260114.2/_next/";